import React, { useCallback } from 'react';
import { Plural, t } from '@lingui/macro';
import { connect } from 'react-redux';
import BukkuTooltip from '../../../Tooltip';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import BukkuTable from '../../../Table/BukkuTable';
import FormatNumber from '../../../FormatNumber';
import BukkuEllipsisTag from '../../../Tag';

export const OutOfStockInfo = {
    title: () => t`Out of Stock Items`,
    onOk: (_, handleOk, action) => {
        const newAction = {...action};
        newAction.request.inventory_check_confirm = true;
        handleOk(newAction);
    },
    bodyStyle: {paddingBottom: 0},
    noPasscode: true,
    width: 700,
};

function OutOfStock(props) {
    // Redux
    const { items } = props;

    const dataSource = items;

    const renderQuantity = useCallback((type = 'default') => {
        const mainColor = type === 'default' ? 'black' : '#cf1322';
        const subColor = type === 'default' ? 'grey' : '#ff7875';

        return function (text, record) {
            const { base_unit_label } = record;
            return (
                <span style={{lineHeight: 1}}>
                    <p style={{color: mainColor, marginBottom: 0}}>
                        <FormatNumber amount={text} dp={2} dp2={4} />
                    </p>
                    <p style={{color: subColor, marginBottom: 0}}>
                        <sub style={{bottom: 0}}>{base_unit_label || ''}</sub>
                    </p>
                </span>
            );
        };
    }, []);

    const columns = [
        {
            key: 'thumbnail_url',
            width: 60,
            render: (text, record) => {
                const src = record.thumbnail_url || '/assets/img/product-placeholder.png';
                return (
                    <div style={{textAlign: 'center', minWidth: 50}}>
                        <img
                            style={{
                                maxWidth: 50,
                                maxHeight: 50,
                                border: "1px solid #BEBEBE50",
                                objectFit: "contain",
                                width: "100%",
                                height: "50px"}}
                            src={src}
                            alt=""
                        />
                    </div>
                );
            },
        },
        {
            title: t`Item`,
            dataIndex: 'product_name',
            key: 'product_name',
            width: 140,
            render: (text, record) => (
                <BukkuTooltip
                    title={text}
                    // prevent off-place tooltip when there's only one product
                    // popupType={dataSource.length === 1 ? "modal" : "parent"}
                >
                    <div style={{
                    // 'white-space': 'nowrap',
                    // 'overflow': 'hidden',
                    // 'text-overflow': 'ellipsis',
                        maxWidth: 140,
                    }}
                    >
                        <span>{text}</span>
                        &nbsp;
                        {record.is_archived ? <EyeInvisibleOutlined /> : null}
                    </div>
                </BukkuTooltip>
            ),
        },
        {
            title: t`Location`,
            dataIndex: 'location_code',
            key: 'location_code',
            align: 'left',
            width: 70,
            render: (text, record) => (
                <BukkuTooltip
                    title={record.location_name}
                    placement="right"
                    // popupType={dataSource.length === 1 ? "modal" : "parent"}
                >
                    <BukkuEllipsisTag style={{marginRight: 0}}>{record.location_code}</BukkuEllipsisTag>
                </BukkuTooltip>
            ),
        },
        {
            title: t`Current Qty`,
            dataIndex: 'current_balance',
            key: 'current_balance',
            align: 'right',
            width: 90,
            render: renderQuantity(),
        },
        {
            title: t`Qty`,
            dataIndex: 'quantity',
            key: 'quantity',
            align: 'right',
            width: 90,
            render: renderQuantity(),
        },
        {
            title: t`Final Qty`,
            dataIndex: 'target_balance',
            key: 'target_balance',
            align: 'right',
            width: 90,
            render: renderQuantity('red'),
        },
    ];

    return (
        <div style={{minHeight: 300}}>
            <div style={{marginBottom: 16}}>
                <Plural
                    value={dataSource.length}
                    one="The following item is getting out of stock, do you want to proceed?"
                    other="The following items are getting out of stock, do you want to proceed?"
                />
            </div>
            <BukkuTable
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                hideTopPagination
                defaultPageSize={5}
                scrollY={240}
            />
        </div>
    );
}

export default connect(() => ({
}))(OutOfStock);
